import { mapState, mapGetters, mapMutations } from 'vuex'

export const authorizationCheckMixin = {
  computed: {
    ...mapState('user', ['user', 'fetching']),
    ...mapGetters('user', ['isAuthenticated'])
  },
  methods: {
    ...mapMutations('user', ['pushOnetimeCallback']),

    // Checks if the signed-in user matches the provided authorized user uuid, and if not redirects to a provided route
    // Returns a promise that resolves/rejects based on whether the signed-in user is authorized, ensuring that a pending /current_user request is complete before the check is performed
    redirectIfUnauthorized(userUuidToAuthorize, redirectRoute) {
      return new Promise((resolve, reject) => {
        if (!userUuidToAuthorize) {
          resolve()
          return
        }
        if (this.fetching) {
          this.pushOnetimeCallback(() => {
            if (!this.isAuthenticated || this.user.uuid !== userUuidToAuthorize) {
              this.$router.push(redirectRoute)
              reject('Unauthorized')
            } else {
              resolve()
            }
          })
        } else {
          if (!this.isAuthenticated || this.user.uuid !== userUuidToAuthorize) {
            this.$router.replace(redirectRoute)
            reject('Unauthorized')
          } else {
            resolve()
          }
        }
      })
    }
  }
}
